import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { Column, Form, Modal, Padding, Input } from '../../..'

const { FormGroup, FormHeader, Label } = Form

class FilterForm extends PureComponent {
    static propTypes = {
        selectedLog: PropTypes.shape({
            id: PropTypes.number,
            user_id: PropTypes.string,
            name: PropTypes.string,
            email: PropTypes.string,
            ip: PropTypes.string,
            method: PropTypes.string,
            url: PropTypes.string,
            full_url: PropTypes.string,
            request_content: PropTypes.string,
            response_content: PropTypes.string,
            response_status: PropTypes.string,
            created_at: PropTypes.string,
        }),
        isOpen: PropTypes.bool,
        onClickCancel: PropTypes.func,
        t: PropTypes.func.isRequired,
    }

    static defaultProps = {
        selectedLog: PropTypes.shape({
            id: null,
            user_id: null,
            name: null,
            email: null,
            ip: null,
            method: null,
            url: null,
            full_url: null,
            request_content: null,
            response_content: null,
            response_status: null,
            created_at: null,
        }),
        isOpen: false,
        onClickCancel: () => null,
    }

    stringToJson = (str) => {
        try {
            const json = JSON.parse(str)
            return JSON.stringify(json, undefined, 2)
        } catch (e) {
            return str
        }
    }

    render() {
        const { isOpen, onClickCancel, selectedLog, t } = this.props
        const { user_id, email, name, ip, method, url, full_url, request_content, response_content, response_status, created_at } = selectedLog
        return (
            <Modal isOpen={isOpen} onClose={onClickCancel} minWidth="419px" scrollable>
                <Form>
                    <FormHeader>
                        <Padding left right bottom size="sm">
                            <Column>{t('Action log')}</Column>
                        </Padding>
                    </FormHeader>
                    <FormGroup title={t('User info')}>
                        <Label id="user_id" label={t('User ID')}>
                            <Input id="user_id" name="user_id" type="text" size="md" value={user_id} disabled />
                        </Label>
                        <Label id="name" label={t('Name')}>
                            <Input id="name" name="name" type="text" size="md" value={name} disabled />
                        </Label>
                        <Label id="email" label={t('Email')}>
                            <Input id="email" name="email" type="text" size="md" value={email} disabled />
                        </Label>
                        <Label id="ip" label={t('IP')}>
                            <Input id="ip" name="ip" type="text" size="md" value={ip} disabled />
                        </Label>
                    </FormGroup>
                    <FormGroup title={t('Request info')}>
                        <Label id="method" label={t('Method')}>
                            <Input id="method" name="method" type="text" size="md" value={method} disabled />
                        </Label>
                        <Label id="created_at" label={t('Date')}>
                            <Input id="created_at" name="created_at" type="text" size="md" value={created_at} disabled />
                        </Label>
                        <Label id="url" label={t('URL')}>
                            <Input id="url" name="url" type="text" size="xl" value={url} disabled />
                        </Label>
                        <Label id="full_url" label={t('Full URL')}>
                            <Input id="full_url" name="full_url" type="text" size="xl" value={full_url} disabled />
                        </Label>
                        {method !== 'DELETE' && (
                            <Label id="request_content" label={t('Request Content')}>
                                <Input
                                    id="request_content"
                                    name="request_content"
                                    type="textarea"
                                    size="xl"
                                    value={this.stringToJson(request_content)}
                                    disabled
                                />
                            </Label>
                        )}
                    </FormGroup>
                    <FormGroup title={t('Response info')}>
                        <Label id="response_status" label={t('Response status')}>
                            <Input id="response_status" name="response_status" type="text" size="xl" value={response_status} disabled />
                        </Label>
                        <Label id="response_content" label={t('Response Content')}>
                            <Input
                                id="response_content"
                                name="response_content"
                                type="textarea"
                                size="xl"
                                value={this.stringToJson(response_content)}
                                disabled
                            />
                        </Label>
                    </FormGroup>
                </Form>
            </Modal>
        )
    }
}

export default withTranslation()(FilterForm)
